import { TypedUseSelectorHook, useDispatch as useDispatchRedux, useSelector as useSelectorRedux } from "react-redux";
import type { AppDispatch, RootState } from "../Components/Providers/Provider.Reducer";

export type { RootState, AppDispatch };
export const useDispatch: () => AppDispatch = useDispatchRedux;
export const useSelector: TypedUseSelectorHook<RootState> = useSelectorRedux;
